import React from 'react';
import { animated, useSpring, config } from '@react-spring/web';

export default function TransitionOpacityReveal({
  children,
  isVisible,
  slow = false,
  className = null,
  style = null,
  animationRef = null,
}) {
  const springProps = useSpring({
    opacity: isVisible ? 1.0 : 0.0,
    ref: animationRef,
    config: slow ? config.slow : config.default,
  });

  return (
    <animated.div className={className} style={{ ...springProps, ...style }}>
      {children}
    </animated.div>
  );
}
